import { tv } from 'tailwind-variants'

import type { StatementStatusKey } from '../stores'

const statusVariants = tv({
  slots: {
    dot: 'bg-neutral-400',
  },
  variants: {
    status: {
      notStarted: {},
      enqueued: { dot: 'bg-amber-500' },
      segmenting: { dot: 'bg-sky-500' },
      recognizing: { dot: 'bg-indigo-500' },
      extracting: { dot: 'bg-blue-500' },
      categorizing: { dot: 'bg-violet-500' },
      duplicated: {},
      succeeded: { dot: 'bg-emerald-500' },
      failed: { dot: 'bg-red-500' },
    },
  },
  defaultVariants: {
    status: 'notStarted',
  },
})

export const getStatusDotClass = (status: StatementStatusKey) =>
  statusVariants({ status }).dot()
